import { ApolloClient, InMemoryCache, DefaultOptions } from "@apollo/client";

// default options are added so any updates can be reflected automatically in the next get page
// TODO use SSG with push notif updated

const isServer = typeof window === "undefined";
const graphqlUri = isServer ? process.env.SERVER_SIDE_GRAPHQL : process.env.NEXT_PUBLIC_GRAPHQL_URL;

const client = new ApolloClient({
  uri: graphqlUri,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "ignore",
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all",
    },
  },
});

export default client;
